import { clientCookie } from './clientCookie';

export const PENDING_PIX_COOKIE_NAME = 'gn_pix_pending_gamification';
export const PENDING_PIX_COOKIE_TTL_DAYS = 1;
const ENTRY_TTL_HOURS = 24;

export interface IPendingPixGamification {
  transactionId: string;
  bundleNameId: string;
  profileId: string | number;
  generatedAt: string;
}

export function isPendingPixStale(entry: IPendingPixGamification): boolean {
  const generatedAt = new Date(entry.generatedAt).getTime();
  if (Number.isNaN(generatedAt)) return true;
  const ageMs = Date.now() - generatedAt;
  return ageMs > ENTRY_TTL_HOURS * 60 * 60 * 1000;
}

export function parsePendingPixGamification(
  raw: string | null | undefined
): IPendingPixGamification | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    if (
      typeof parsed?.transactionId !== 'string' ||
      typeof parsed?.generatedAt !== 'string'
    ) {
      return null;
    }
    if (isPendingPixStale(parsed)) return null;
    return parsed as IPendingPixGamification;
  } catch {
    return null;
  }
}

export function serializePendingPixGamification(
  data: IPendingPixGamification
): string {
  return encodeURIComponent(JSON.stringify(data));
}

export function readPendingPixGamification(): IPendingPixGamification | null {
  return parsePendingPixGamification(clientCookie.get(PENDING_PIX_COOKIE_NAME));
}

export function savePendingPixGamification(
  data: IPendingPixGamification
): void {
  clientCookie.set(
    PENDING_PIX_COOKIE_NAME,
    serializePendingPixGamification(data),
    PENDING_PIX_COOKIE_TTL_DAYS
  );
}

export function clearPendingPixGamification(): void {
  clientCookie.erase(PENDING_PIX_COOKIE_NAME);
}

export function hasLockedPixGamification(): boolean {
  return readPendingPixGamification() !== null;
}
